import { FC, useState, createContext, useEffect } from 'react';
import { LoggedInUser } from 'src/models/user.interface';

type LoggedInUserContextType = {
  contextLoggedInUser: LoggedInUser | null;
  getContextLoggedInUser: () => void;
};

export const LoggedInUserContext = createContext<LoggedInUserContextType>(
  {} as LoggedInUserContextType
);

export const LoggedInUserProvider: FC = ({ children }) => {
  const [contextLoggedInUser, setContextLoggedInUser] =
    useState<LoggedInUser | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const getContextLoggedInUser = () => {
    const user = JSON.parse(localStorage.getItem('loggedInUser') || 'null');
    setContextLoggedInUser(user);
    setLoading(false);
  };

  useEffect(() => {
    getContextLoggedInUser();
  }, []);

  return (
    <LoggedInUserContext.Provider
      value={{ contextLoggedInUser, getContextLoggedInUser }}
    >
      {loading ? <></> : children}
    </LoggedInUserContext.Provider>
  );
};
